import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import { components } from '@glowforge/ui-common';

import SubmitActions from 'app/common/components/forms/submit-actions';
import { validateAccountInfo, GeneralAccountFields } from '../settings/general-account-fields';
import './create-form.less';

const { Notification, Markdown } = components;

const CreateAccountForm = (props) => {
  let message = null;
  let error = null;
  if (props.success) {
    message = CreateAccountForm.successMassage(props.pageStrings);
  } else if (props.userAlreadyExistsError) {
    message = CreateAccountForm.userExistsMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  } else if (props.unacceptableEmailError) {
    message = CreateAccountForm.unacceptableEmailMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  } else if (props.genericError) {
    // Unexpected case, should not be triggered
    message = CreateAccountForm.genericIssueMassage(props.pageStrings);
    // Mark as error to not display success message, but do not display error message either
    error = ' ';
  }

  return (
    <form className='CreateAccountForm' onSubmit={props.handleSubmit}>
      {message}
      {GeneralAccountFields(false)}
      {CreateAccountForm.acceptTermsMessage(props.pageStrings)}
      <SubmitActions
        {...props}
        submitText={props.pageStrings['create-account-button-text']}
        inProgressMessage={'Creating...'}
        successMessage={'Created new account'}
        error={error} />
    </form>);
};

CreateAccountForm.successMassage = pageStrings => (
  <Notification level='success' text={pageStrings['create-account-success-message']} hideHeader />
);

CreateAccountForm.userExistsMassage = pageStrings => (
  <Notification level='error' text={pageStrings['create-account-user-already-exists']} hideHeader />
);

CreateAccountForm.unacceptableEmailMassage = pageStrings => (
  <Notification level='error' text={pageStrings['create-account-unacceptable-email-error-message']} hideHeader />
);

CreateAccountForm.genericIssueMassage = pageStrings => (
  <Notification level='error' text={pageStrings['create-account-generic-issue']} hideHeader />
);

CreateAccountForm.acceptTermsMessage = pageStrings => (
  <div className='terms'>
    <Markdown source={pageStrings['create-account-privacy-and-terms']} />
  </div>
);

CreateAccountForm.propTypes = {
  success: PropTypes.bool,
  userAlreadyExistsError: PropTypes.bool,
  unacceptableEmailError: PropTypes.bool,
  genericError: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  pageStrings: PropTypes.shape({
    'create-account-success-message': PropTypes.string.isRequired,
    'create-account-user-already-exists': PropTypes.string.isRequired,
    'create-account-unacceptable-email': PropTypes.string.isRequired,
    'create-account-generic-issue': PropTypes.string.isRequired,
    'create-account-privacy-and-terms': PropTypes.string.isRequired,
    'create-account-button-text': PropTypes.string.isRequire,
  }).isRequired,
};

CreateAccountForm.defaultProps = {
  success: false,
  userAlreadyExistsError: false,
  unacceptableEmailError: false,
  genericError: false,
};

// Decorate the form component
export default reduxForm({
  form: 'CreateAccount',
  enableReinitialize: true,
  validate: validateAccountInfo,
})(CreateAccountForm);



// WEBPACK FOOTER //
// ./app/components/account/create-form.jsx